// Vanilla port of FlightSearchForm.tsx behaviour. Operates on any element with
// [data-flight-search]; option/airport data is rendered server-side in the
// flight_search_form macro, so this only handles interaction + submit.

import { flightResultsHref } from './flightLandingPages.js';
import { trackFlightSearchSubmitted } from './flightSearchAnalytics.js';

function initForm(root) {
  const fromBtn = root.querySelector('[data-fs-from]');
  const fromMenu = root.querySelector('[data-fs-from-menu]');
  const fromValue = root.querySelector('[data-fs-from-value]');
  const fromCodeInput = root.querySelector('[data-fs-from-code]');
  const tripSelect = root.querySelector('[data-fs-trip]');
  const dateSelect = root.querySelector('[data-fs-date]');
  const specificDates = root.querySelector('[data-fs-specific]');
  const depInput = root.querySelector('[data-fs-dep]');
  const retInput = root.querySelector('[data-fs-ret]');
  const travelersBtn = root.querySelector('[data-fs-travelers]');
  const travelersMenu = root.querySelector('[data-fs-travelers-menu]');
  const travelersValue = root.querySelector('[data-fs-travelers-value]');
  const submitBtn = root.querySelector('[data-fs-submit]');

  const travelers = { adults: 1, children: 0, infants: 0 };

  function travelerSummary() {
    let s = travelers.adults === 1 ? '1 adult' : `${travelers.adults} adults`;
    if (travelers.infants > 0) s += `, ${travelers.infants} infant${travelers.infants > 1 ? 's' : ''}`;
    if (travelers.children > 0) s += `, ${travelers.children} child${travelers.children > 1 ? 'ren' : ''}`;
    return s;
  }

  function renderTravelers() {
    if (travelersValue) travelersValue.textContent = travelerSummary();
    root.querySelectorAll('[data-fs-count]').forEach((el) => {
      el.textContent = String(travelers[el.getAttribute('data-fs-count')]);
    });
  }

  // From dropdown
  if (fromBtn && fromMenu) {
    fromBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      fromMenu.hidden = !fromMenu.hidden;
    });
    root.querySelectorAll('[data-fs-option]').forEach((opt) => {
      const choose = () => {
        const code = opt.getAttribute('data-code') || '';
        const label = opt.getAttribute('data-label') || '';
        if (fromCodeInput) fromCodeInput.value = code;
        if (fromValue) fromValue.textContent = label;
        fromMenu.hidden = true;
      };
      if (opt.tagName === 'INPUT') opt.addEventListener('change', choose);
      else opt.addEventListener('click', choose);
    });
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) fromMenu.hidden = true;
    });
  }

  // Date select toggles specific-date inputs
  if (dateSelect && specificDates) {
    const sync = () => {
      specificDates.hidden = dateSelect.value !== 'Between Specific Dates';
    };
    dateSelect.addEventListener('change', sync);
    sync();
  }

  // Travelers
  if (travelersBtn && travelersMenu) {
    travelersBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      travelersMenu.hidden = !travelersMenu.hidden;
    });
    root.querySelectorAll('[data-fs-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.getAttribute('data-fs-step');
        const inc = btn.getAttribute('data-fs-dir') === 'up';
        const min = type === 'adults' ? 1 : 0;
        travelers[type] = inc ? travelers[type] + 1 : Math.max(min, travelers[type] - 1);
        renderTravelers();
      });
    });
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) travelersMenu.hidden = true;
    });
  }
  renderTravelers();

  const params = new URLSearchParams(window.location.search);
  const prefillFrom = params.get('fly_from') || params.get('from');
  const prefillTo = params.get('fly_to') || params.get('to');
  if (prefillFrom && fromCodeInput) {
    const match = root.querySelector(`[data-fs-option][data-code="${prefillFrom}"]`);
    if (match) {
      fromCodeInput.value = prefillFrom;
      if (fromValue) fromValue.textContent = match.getAttribute('data-label') || prefillFrom;
    }
  }
  if (prefillTo) {
    const toInput = root.querySelector('[data-fs-to]');
    if (toInput) toInput.value = prefillTo;
  }
  if (params.get('tripType') && tripSelect) {
    tripSelect.value = params.get('tripType');
  }

  // Submit
  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      const code = fromCodeInput ? fromCodeInput.value : '';
      if (!code) {
        alert('Please select a departure airport');
        return;
      }
      const extraParams = {};
      const dateMode = dateSelect ? dateSelect.value : 'Anytime in the next 7 months';
      if (dateMode === 'Between Specific Dates') {
        extraParams.dateSelect = dateMode;
        if (depInput && depInput.value) extraParams.departureDate = depInput.value;
        if (retInput && retInput.value) extraParams.returnDate = retInput.value;
      }
      const tripType = tripSelect ? tripSelect.value : 'day_trip';
      trackFlightSearchSubmitted({
        fly_from: code,
        trip_type: tripType,
        source: 'homepage',
        submit_pathname: window.location.pathname,
        adults: travelers.adults,
        children: travelers.children,
        infants: travelers.infants,
        departure_date: extraParams.departureDate,
        return_date: extraParams.returnDate,
      });
      window.location.href = flightResultsHref({
        fly_from: code,
        tripType,
        adults: String(travelers.adults),
        infants: String(travelers.infants),
        children: String(travelers.children),
        extraParams,
      });
    });
  }
}

export function initFlightSearchForms() {
  document.querySelectorAll('[data-flight-search]').forEach(initForm);
}
